import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionTimerService } from './session-timer.service';
import {SharedDataService} from "./shared-data.service";
import {environment} from "../../environments/environment";


@Injectable()
export class SessionTimerInterceptor implements HttpInterceptor {
  private extendGpaisSessionUrl = environment.apiBaseUrl + '/internalApi/extendSession';

  constructor(private sessionTimerService: SessionTimerService,
              private sharedDataService: SharedDataService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes(this.extendGpaisSessionUrl)) {
      return next.handle(request);
    }
    const timeout = this.sharedDataService.getSessionTimeout();
    this.sessionTimerService.resetSessionTimer(timeout);
    this.sessionTimerService.extendSession();
    return next.handle(request);
  }
}
